// import {
//   ChangeDetectorRef,
//   Component,
//   Inject,
//   OnInit,
//   ViewChild,
// } from '@angular/core';
// import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
// import { PdfViewerComponent, PdfViewerModule } from 'ng2-pdf-viewer';
// import { SafeResourceUrl } from '@angular/platform-browser';
// import { MatIconModule } from '@angular/material/icon';
// import { CommonModule } from '@angular/common';

// @Component({
//   selector: 'app-document-viewer-dialog',
//   standalone: true,
//   imports: [PdfViewerModule, CommonModule, MatIconModule],
//   templateUrl: './document-viewer-dialog.component.html',
//   styleUrls: ['./document-viewer-dialog.component.scss'],
// })
// export class DocumentViewerDialogComponent implements OnInit {
//   @ViewChild(PdfViewerComponent) pdfComponent!: PdfViewerComponent;

//   safeUrl: SafeResourceUrl = '';
//   searchText: string = '';
//   selectedSearchType: string = 'Document Name';
//   pdf: any;
//   showPages: number[] = [];
//   currentPage: number = 1;
//   totalPages: number = 1;
//   isPdfReady = false;

//   constructor(
//     public dialogRef: MatDialogRef<DocumentViewerDialogComponent>,
//     private cdr: ChangeDetectorRef,
//     @Inject(MAT_DIALOG_DATA)
//     public data: {
//       url: string;
//       searchText?: string;
//       selectedSearchType?: string;
//     }
//   ) {
//     this.searchText = (this.data.searchText ?? '').trim();
//     this.selectedSearchType = this.data.selectedSearchType || 'Document Name';
//   }

//   ngOnInit() {}

//   ngAfterViewInit(): void {
//     setTimeout(() => {
//       const base64 = this.data.url.startsWith('data:application/pdf;base64,')
//         ? this.data.url
//         : 'data:application/pdf;base64,' + this.data.url;

//       this.safeUrl = base64;
//       this.cdr.detectChanges(); // Ensure Angular updates the view
//     }, 100);
//   }

//   // ngAfterViewInit(): void {
//   //   this.safeUrl =
//   //     'https://file-examples.com/storage/fe5b1b3e2f3b4b9c8e4b5c1/2017/10/file-sample_150kB.pdf';
//   //   this.searchText = 'Angular PDF Search Highlight Test';
//   //   this.selectedSearchType = 'Document Content';
//   //   this.cdr.detectChanges();
//   // }

//   isPdfLoaded = false;
//   isSearchCompleted = false;

//   // afterLoadComplete(pdf: any) {
//   //   console.log('PDF loaded:', pdf);
//   //   this.pdf = pdf;
//   //   this.totalPages = pdf.numPages;
//   //   this.isPdfLoaded = true;

//   //   if (this.selectedSearchType === 'Document Content' && this.searchText) {
//   //     this.findAllPagesWithText();
//   //   } else {
//   //     this.showPages = [1];
//   //     this.currentPage = 1;
//   //     this.isSearchCompleted = true;
//   //   }
//   // }
//   afterLoadComplete(pdf: any) {
//     console.log('PDF loaded:', pdf);
//     this.pdf = pdf;
//     this.totalPages = pdf.numPages;
//     this.isPdfLoaded = true;

//     // Always render all pages, highlight if searchText is present
//     this.showPages = Array.from({ length: this.totalPages }, (_, i) => i + 1);
//     this.currentPage = 1;
//     this.isSearchCompleted = true;
//     this.cdr.detectChanges();
//   }

//   findAllPagesWithText() {
//     const searchTerm = this.searchText.toLowerCase().trim();
//     const promises: Promise<number>[] = [];

//     for (let i = 1; i <= this.pdf.numPages; i++) {
//       promises.push(
//         this.pdf.getPage(i).then((page: any) =>
//           page.getTextContent().then((content: any) => {
//             const pageText = content.items
//               .map((item: any) => item.str)
//               .join(' ')
//               .toLowerCase();
//             return pageText.includes(searchTerm) ? i : -1;
//           })
//         )
//       );
//     }

//     Promise.all(promises).then((pages: number[]) => {
//       this.showPages = pages.filter((p) => p !== -1);
//       this.currentPage = this.showPages.length ? this.showPages[0] : 1;

//       // Force re-render by resetting safeUrl
//       const originalUrl = this.safeUrl;
//       this.safeUrl = '';
//       this.cdr.detectChanges();

//       setTimeout(() => {
//         this.safeUrl = originalUrl;
//         this.isSearchCompleted = true;
//         this.cdr.detectChanges();
//       }, 100);
//     });
//   }

//   onTextLayerRendered() {
//     if (!this.searchText || this.selectedSearchType !== 'Document Content')
//       return;

//     const searchTerm = this.searchText.trim();
//     const regex = new RegExp(this.escapeRegExp(searchTerm), 'gi');

//     setTimeout(() => {
//       const layers = document.querySelectorAll('.textLayer');
//       layers.forEach((layer) => {
//         const textDivs = layer.querySelectorAll('span');

//         textDivs.forEach((span) => {
//           const originalText = span.textContent || '';
//           if (regex.test(originalText)) {
//             const highlightedHTML = originalText.replace(regex, (match) => {
//               return `<span class="highlight">${match}</span>`;
//             });
//             span.innerHTML = highlightedHTML;
//           }
//         });
//       });

//       console.log(
//         'Text layer rendered and highlighted for page:',
//         this.currentPage
//       );
//     }, 300);
//   }

//   escapeRegExp(str: string) {
//     return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
//   }

//   showPrevPage() {
//     const idx = this.showPages.indexOf(this.currentPage);
//     if (idx > 0) {
//       this.currentPage = this.showPages[idx - 1];
//       this.cdr.detectChanges(); // Force re-render
//     }
//   }

//   showNextPage() {
//     const idx = this.showPages.indexOf(this.currentPage);
//     if (idx < this.showPages.length - 1) {
//       this.currentPage = this.showPages[idx + 1];
//       this.cdr.detectChanges(); // Force re-render
//     }
//   }

//   onClose(): void {
//     this.dialogRef.close();
//   }

//   openPdfInNewTab(base64Pdf: string) {
//     const byteCharacters = atob(
//       base64Pdf.replace(/^data:application\/pdf;base64,/, '')
//     );
//     const byteNumbers = new Array(byteCharacters.length);
//     for (let i = 0; i < byteCharacters.length; i++) {
//       byteNumbers[i] = byteCharacters.charCodeAt(i);
//     }
//     const byteArray = new Uint8Array(byteNumbers);
//     const blob = new Blob([byteArray], { type: 'application/pdf' });
//     const blobUrl = URL.createObjectURL(blob);
//     window.open(blobUrl, '_blank');
//   }

//   onViewMoreClick(): void {
//     if (this.selectedSearchType === 'Document Content' && this.searchText) {
//       this.findAllPagesWithText();
//     } else {
//       this.safeUrl = this.data.url.startsWith('data:application/pdf;base64,')
//         ? this.data.url
//         : 'data:application/pdf;base64,' + this.data.url;
//       this.showPages = [1];
//       this.currentPage = 1;
//     }
//   }
// }

import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PdfViewerComponent, PdfViewerModule } from 'ng2-pdf-viewer';
import { SafeResourceUrl } from '@angular/platform-browser';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-document-viewer-dialog',
  standalone: true,
  imports: [PdfViewerModule, CommonModule, MatIconModule],
  templateUrl: './document-viewer-dialog.component.html',
  styleUrls: ['./document-viewer-dialog.component.scss'],
})
export class DocumentViewerDialogComponent implements OnInit {
  @ViewChild(PdfViewerComponent) pdfComponent!: PdfViewerComponent;

  safeUrl: SafeResourceUrl = '';
  searchText: string = '';
  selectedSearchType: string = 'Document Name';
  pdf: any;
  showPages: number[] = [];
  currentPage: number = 1;
  totalPages: number = 1;
  isPdfReady = false;
  isPdfLoaded = false;
  isSearchCompleted = false;
  documentLink: string;

  constructor(
    public dialogRef: MatDialogRef<DocumentViewerDialogComponent>,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      url: string;
      searchText?: string;
      selectedSearchType?: string;
      documentLink?: string;
    }
  ) {
    console.log(this.data, 'Data');
    this.searchText = (this.data.searchText ?? '').trim();
    this.selectedSearchType = this.data.selectedSearchType || 'Document Name';
    this.documentLink = this.data.documentLink || '';
  }

  // ngOnInit(): void {
  //   const url = this.data.url.trim();
  //   console.log(url, 'pdf url coming');
  //   const base64 = url.startsWith('data:application/pdf;base64,')
  //     ? url
  //     : 'data:application/pdf;base64,' +
  //       url.replace(/^application\/pdf;base64,/, '');

  //   this.safeUrl = base64;
  //   console.log(this.safeUrl, 'this.safeUrl');
  // }

  ngOnInit(): void {
    const normalized = this.normalizePdfUrl(this.data.url);
    if (normalized) {
      this.safeUrl = normalized;
    } else {
      console.warn('Invalid PDF format');
    }
  }

  normalizePdfUrl(url: string): string | null {
    url = url.trim();

    if (url.startsWith('data:application/pdf;base64,')) {
      return url;
    } else if (url.startsWith('application/pdf;base64,')) {
      return 'data:' + url;
    } else if (url.startsWith('data:') && url.includes('base64,')) {
      // Not a PDF
      return null;
    } else {
      // Assume raw base64 PDF
      return 'data:application/pdf;base64,' + url;
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const url = this.data.url.trim();
      const base64 = url.startsWith('data:application/pdf;base64,')
        ? url
        : 'data:application/pdf;base64,' +
          url.replace(/^application\/pdf;base64,/, '');

      this.safeUrl = base64;
      this.cdr.detectChanges();
    }, 100);
  }

  afterLoadComplete(pdf: any) {
    console.log('PDF loaded:', pdf);
    this.pdf = pdf;
    this.totalPages = pdf.numPages;
    this.isPdfLoaded = true;
    this.currentPage = 1;
    this.isSearchCompleted = true;
    this.cdr.detectChanges();

    // Manually trigger text layer rendering after a short delay
    setTimeout(() => this.onTextLayerRendered(), 500);
  }

  findAllPagesWithText() {
    const searchTerm = this.searchText.toLowerCase().trim();
    const promises: Promise<number>[] = [];

    for (let i = 1; i <= this.pdf.numPages; i++) {
      promises.push(
        this.pdf.getPage(i).then((page: any) =>
          page.getTextContent().then((content: any) => {
            const pageText = content.items
              .map((item: any) => item.str)
              .join(' ')
              .toLowerCase();
            return pageText.includes(searchTerm) ? i : -1;
          })
        )
      );
    }

    Promise.all(promises).then((pages: number[]) => {
      this.showPages = pages.filter((p) => p !== -1);
      this.isSearchCompleted = true;
      this.cdr.detectChanges();
    });
  }

  // workign and adding text in pdf to highlight
  // onTextLayerRendered(): void {
  //   if (!this.searchText || this.selectedSearchType !== 'Document Content')
  //     return;

  //   const searchTerm = this.searchText.trim();
  //   const regex = new RegExp(this.escapeRegExp(searchTerm), 'gi');

  //   const layers = document.querySelectorAll('.textLayer');
  //   layers.forEach((layer) => {
  //     const textDivs = layer.querySelectorAll('span');

  //     textDivs.forEach((span) => {
  //       const originalText = span.textContent || '';
  //       if (regex.test(originalText)) {
  //         const highlightedHTML = originalText.replace(regex, (match) => {
  //           return `<span class="highlight">${match}</span>`;
  //         });
  //         span.innerHTML = highlightedHTML;
  //       }
  //     });
  //   });
  // }

  // onTextLayerRendered(): void {
  //   if (!this.searchText || this.selectedSearchType !== 'Document Content')
  //     return;

  //   const searchTerm = this.searchText.trim();
  //   const regex = new RegExp(this.escapeRegExp(searchTerm), 'gi');

  //   const layers = document.querySelectorAll('.textLayer');
  //   layers.forEach((layer) => {
  //     const textDivs = layer.querySelectorAll('span');

  //     textDivs.forEach((span) => {
  //       const originalText = span.textContent || '';
  //       if (regex.test(originalText)) {
  //         const highlightedText = originalText.replace(regex, (match) => {
  //           return `<mark class="highlight">${match}</mark>`;
  //         });
  //         span.innerHTML = highlightedText;
  //       }
  //     });
  //   });
  // }

  onTextLayerRendered(): void {
    if (!this.searchText || this.selectedSearchType !== 'Document Content')
      return;

    const searchTerm = this.searchText.trim().toLowerCase();
    console.log(searchTerm, 'searchTerm');

    const layers = document.querySelectorAll('.textLayer');
    layers.forEach((layer) => {
      const textDivs = layer.querySelectorAll('span');

      textDivs.forEach((span) => {
        const text = span.textContent?.toLowerCase() || '';
        if (text.includes(searchTerm)) {
          span.style.backgroundColor = 'yellow';
          span.style.borderRadius = '2px';
          span.style.padding = '0 2px';
        }
      });
    });
  }

  escapeRegExp(str: string) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  showPrevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.cdr.detectChanges();
      setTimeout(() => this.onTextLayerRendered(), 300);
    }
  }

  showNextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.cdr.detectChanges();
      setTimeout(() => this.onTextLayerRendered(), 300);
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }

  openPdfInNewTab(base64Pdf: string) {
    const byteCharacters = atob(
      base64Pdf.replace(/^data:application\/pdf;base64,/, '')
    );
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, '_blank');
  }

  // onViewMoreClick(): void {
  //   if (this.selectedSearchType === 'Document Content' && this.searchText) {
  //     this.findAllPagesWithText();
  //   } else {
  //     this.safeUrl = this.data.url.startsWith('data:application/pdf;base64,')
  //       ? this.data.url
  //       : 'data:application/pdf;base64,' + this.data.url;
  //     this.showPages = [1];
  //     this.currentPage = 1;
  //   }
  // }
  onViewMoreClick(): void {
    if (this.documentLink) {
      window.open(this.documentLink, '_blank');
    }
  }
}
